import { MfeLoad } from '@carvana/microfrontend';
import { useEffect } from 'react';
import { getMfeCacheBuster } from '@/common/MicroFrontEnds';
import { SOFTPULL_MODULE } from '~/constants/common/MfeModules';
import { staticCdnUrl } from '~/constants/environment';
import { useMfeLoadStore } from '~/state/common/MfeLoadState';

export default function useLoadSoftPullMfe() {
  const record = useMfeLoadStore(state => state.record);

  useEffect(() => {
    MfeLoad({
      files: [
        [
          'SoftPullModule',
          [
            {
              component: 'default',
              chunks: ['styles.css'],
              default: {
                file: 'index.js',
                manifest: `${staticCdnUrl}/softpull-modal-module/assets-manifest.json?v=${getMfeCacheBuster()}`
              }
            }
          ]
        ]
      ]
    });

    // Reset readiness on unmount so a stale value doesn't leak into the next mount.
    return () => {
      record({
        componentName: 'default',
        data: 'teardown',
        moduleName: SOFTPULL_MODULE,
        timestamp: Date.now()
      });
    };
  }, [record]);
}
